import React from 'react';
import styles from './Tabela.module.css';
import iconeExcluir from '../../assets/img/delete.svg';
import iconeIncluir from '../../assets/img/add-user.svg';
import iconeVisualizar from '../../assets/img/acompanhar.svg';
import iconeEditar from '../../assets/img/edit.svg';

const Tabela = ({
  dados,
  mostraColunaAcoes = true,
  habilitaInclusao,
  acaoInclusao,
  habilitaExclusao,
  acaoExclusao,
  habilitaEdicao,
  acaoEdicao,
  habilitaInformacao,
  acaoInformacao,
  headers,
  mensagemTabelaVazia = 'Dados não encontrados :(',
}) => {
  if (!dados || dados.length === 0) {
    return (
      <div className={styles.noData}>
        <div>{mensagemTabelaVazia}</div>
      </div>
    );
  }
  const temAcoes =
    mostraColunaAcoes &&
    (!!acaoInclusao || !!acaoExclusao || !!acaoEdicao || !!acaoInformacao);
  const dadosOrganizados = organizaDados(dados, headers);
  return (
    <>
      <div>
        <table className="th-fixo cards mob">
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header.key}>{header.value}</th>
              ))}
              {temAcoes && <th> Ações</th>}
            </tr>
          </thead>
          <tbody>
            {dadosOrganizados.map((linha, i) => (
              <tr key={i}>
                {Object.keys(linha)
                  .filter((coluna) => coluna !== 'original')
                  .map((coluna, j) => (
                    <td key={j} data-th={headers[j].value}>
                      {linha[coluna]?.render
                        ? linha[coluna].render(
                            linha.original[coluna],
                            linha.original,
                          )
                        : linha[coluna] || ''}
                    </td>
                  ))}
                {temAcoes && (
                  <td>
                    <div className="acoes">
                      {acaoInformacao && (
                        <div
                          style={{
                            visibility: habilitaInformacao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Visualizar Acessos"
                            className="info"
                            {...(acaoInformacao
                              ? {
                                  onClick: () => acaoInformacao(linha.original),
                                }
                              : {})}
                          >
                            {' '}
                            <img
                              className="img-card"
                              alt="visualizar acessos"
                              //src={iconeIncluir}
                              src={iconeVisualizar}
                            />
                          </button>
                        </div>
                      )}

                      {acaoInclusao && (
                        <div
                          style={{
                            visibility: habilitaInclusao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Incluir"
                            className="incluir"
                            {...(acaoInclusao
                              ? {
                                  onClick: (event) => {
                                    event.preventDefault();
                                    acaoInclusao(linha.original);
                                  },
                                }
                              : {})}
                          >
                            <img
                              className="img-card"
                              alt="ícone incluir"
                              src={iconeIncluir}
                            />
                          </button>
                        </div>
                      )}
                      {acaoEdicao && (
                        <div
                          style={{
                            visibility: habilitaEdicao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Editar"
                            className="edit"
                            {...(acaoEdicao
                              ? { onClick: () => acaoEdicao(linha.original) }
                              : {})}
                          >
                            <img
                              className="img-card"
                              alt="ícone excluir"
                              src={iconeEditar}
                            />
                          </button>
                        </div>
                      )}

                      {acaoExclusao && (
                        <div
                          style={{
                            visibility: habilitaExclusao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Excluir"
                            className="delete"
                            {...(acaoExclusao
                              ? {
                                  onClick: (event) => {
                                    event.preventDefault();
                                    acaoExclusao(linha.original);
                                  },
                                }
                              : {})}
                          >
                            <img
                              className="img-card"
                              alt="ícone excluir"
                              src={iconeExcluir}
                            />
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

function organizaDados(lista, headers) {
  const listaOrganizada = [];
  lista.forEach((linha) => {
    let linhaOrganizada = {};
    headers.forEach((header) => {
      const obj = {};
      obj[header.key] = header.render
        ? { render: header.render }
        : linha[header.key];
      linhaOrganizada = { ...linhaOrganizada, ...obj };
    });

    linhaOrganizada.original = linha;
    listaOrganizada.push(linhaOrganizada);
  });

  return listaOrganizada;
}

export default Tabela;
